import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Session } from "../session/session";
import { useInterval } from "../../hooks/framework/useInterval";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { setAccessToken } from "../redux/slices/sessionSlice";
import { fetchAppOptions } from "../redux/slices/appSlice";
import { handleApiError } from "../../services/baseService";

interface IPrivateRouteProps {
    children: JSX.Element;
}

const CHECK_ACCESS_TOKEN_INTERVAL = 60000; // 60s

export const PrivateRoute = ({ children }: IPrivateRouteProps) => {
    const [loaded, setLoaded] = useState<boolean>(false);
    const accessToken = useAppSelector(({ session }) => session.accessToken);

    const dispatch = useAppDispatch();

    const getAccessToken = () => {
        Session.getAccessToken()
            .then((i) => {
                if (i !== accessToken) {
                    dispatch(setAccessToken(i));
                }
                setLoaded(true);
            })
            .catch(console.error);
    };

    useEffect(() => {
        getAccessToken();
    }, [accessToken]);

    useEffect(() => {
        if (accessToken) {
            const promise = dispatch(fetchAppOptions());

            promise.unwrap().catch(handleApiError);

            return () => {
                promise.abort();
            };
        }
    }, [accessToken]);

    useInterval(getAccessToken, CHECK_ACCESS_TOKEN_INTERVAL);

    if (!loaded) return null;
    return !accessToken ? <Navigate to="/login" replace /> : children;
};
